export interface ServiceAccountSpec {
  name: string;
  "default-devcontainer-id"?: string;
}

export interface ServiceAccount {
  type: "omega/query-omega/service-account/ServiceAccount";
  "app-id": string;
  "service-account-id": string;
  "api-key": string;
  "service-account-spec": ServiceAccountSpec;
}

export type ServiceAccountMap = { [k: string]: ServiceAccount };

export const initServiceAccountMap: ServiceAccountMap = {};

// The display name lives at service-account-spec.name.
export const serviceAccountName = (sa: ServiceAccount | undefined): string =>
  sa?.["service-account-spec"]?.name ?? "";

export const serviceAccountDefaultDevcontainer = (sa: ServiceAccount | undefined): string | null =>
  sa?.["service-account-spec"]?.["default-devcontainer-id"] ?? null;

export const newServiceAccount = (config: {
  appId: string;
  serviceAccountId: string;
  apiKey: string;
  name: string;
}): ServiceAccount => {
  const { appId, serviceAccountId, apiKey, name } = config;
  return {
    type: "omega/query-omega/service-account/ServiceAccount",
    "app-id": appId,
    "service-account-id": serviceAccountId,
    "api-key": apiKey,
    "service-account-spec": { name },
  };
};
